export type AppBrand = 'default' | 'virea' | 'charma'

export const getAppBrand = (): AppBrand => {
  const brand = (window as Window & { __APP_BRAND__?: string }).__APP_BRAND__
  return brand === 'virea' || brand === 'charma' ? brand : 'default'
}

export const getBrandQuery = (): Record<string, string> => {
  return getAppBrand() === 'charma' && window.location.hostname !== 'charma.dev.pacsortonline.com'
    ? { brand: 'charma' }
    : {}
}
